import React, { useState, useContext, useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { ConfigContext } from '../../Context/ConfigContext';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';
import { Chart } from 'primereact/chart';
import StoreSelect from '../../Components/Store';
import { confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import { Column } from 'primereact/column';
import { formatDate, formatedDate } from '../../Helper/constent';
import { Button } from 'primereact/button';

const Settings = () => {
    const { apiHeadersJson, apiUrl, store_id, user_id } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const toast = useRef(null);
    const [activeTab, setActiveTab] = useState('Profile');
    const [isHovered, setIsHovered] = useState(null);
    const [userInfo, setUserinfo] = useState({});
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [deleteFromDate, setDeleteFromDate] = useState('');
    const [deleteToDate, setDeleteToDate] = useState('');
    const [isBackUp, setIsBackUp] = useState(false);
    const [encryptedCode, setEncryptedCode] = useState("");


    // Profile Chart 
    const [userSales, setUserSales] = useState({});
    const [salesChart, setSalesChart] = useState({});
    const [salesChartOptions, setSalesChartOptions] = useState({});

    // Clear & BackUp 
    const [initializeClearing, setInitializeClearing] = useState(false);
    const [cleanTables, setCleanTables] = useState([]);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [permissions, setPermissions] = useState([]);

    ///////////// Tabs \\\\\\\\\\\\\\\\\\\\\\
    const tabs = [
        {
            id: 'Profile',
            title: "Profile",
            icon: "pi pi-user",
            color: "text-blue-600",
            bgColor: "bg-blue-50",
            auths: '',
            checktab: false,
        },
        {
            id: 'todaysSale',
            title: "Today's Sale",
            icon: "pi pi-chart-bar",
            color: "text-purple-600",
            bgColor: "bg-purple-50",
            auths: 'TodaySale',
            checktab: true,
        },
        {
            id: 'clearBackup',
            title: "Clear & Backup",
            icon: "pi pi-database",
            color: "text-blue-600",
            bgColor: "bg-blue-50",
            auths: 'ClearBackup',
            checktab: true,
        },
        {
            id: 'BackUpHistory',
            title: "BackUp History",
            icon: "pi pi-history",
            color: "text-purple-600",
            bgColor: "bg-purple-50",
            auths: 'BackupHistory',
            checktab: true,
        }
    ];

    const tabVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0 },
        active: { scale: 1.05 }
    };


    ///////////// Profile \\\\\\\\\\\\\\\\\\\\\\
    const getInfo = async () => {
        try {
            const response = await axios.get(`${apiUrl}/User/GetUserInfo`, { params: { user_id }, headers });
            const { success, sales, permissions, data, message } = response.data;

            if (success) {
                setUserinfo(data[0]);
                setUserSales(sales);
                setPermissions(permissions);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const data = {
            labels: ['New', 'Modified', 'Removed'],
            datasets: [
                {
                    data: [(userSales?.total_created), userSales?.total_edited, userSales?.total_deleted],
                    backgroundColor: [
                        documentStyle.getPropertyValue('--green-500'),
                        documentStyle.getPropertyValue('--blue-500'),
                        documentStyle.getPropertyValue('--red-500'),
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--green-400'),
                        documentStyle.getPropertyValue('--blue-400'),
                        documentStyle.getPropertyValue('--red-400'),
                    ]
                }
            ]
        }
        const options = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true
                    }
                }
            }
        };

        setSalesChart(data);
        setSalesChartOptions(options);
    }, [userSales]);

    useEffect(() => {
        activeTab === 'Profile' && getInfo();
    }, [user_id, activeTab]);

    useEffect(() => {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        let todays_date = [year, month, day].join('-');
        setFromDate(todays_date);
        setToDate(todays_date);
    }, []);


    ///////////// Sale Print \\\\\\\\\\\\\\\\\\\\\\
    const handlePrint = () => {
        if (!store_id || !fromDate || !toDate) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please Select All The Fields...!', life: 3000 });
            return;
        }
        window.open(`#/TodaysPrint/${store_id}/${fromDate}/${toDate}/${isBackUp && encryptedCode ? encryptedCode : ""}`, '_blank');
    }

    ///////////// Clear & BackUp \\\\\\\\\\\\\\\\\\\\\\

    const handleClearDataConformation = (export_only) => {
        console.log('export_only', export_only)
        confirmDialog({
            message: `Are you sure you want to ${export_only === "2" ? "Backup Data" : `initialize clear From : ${formatedDate(deleteFromDate)} To : ${formatedDate(deleteToDate)}`}?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => handleClearData(export_only),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: `${export_only === "2" ? "Backup Data" : "initialize clear"} operation cancelled`, life: 3000 });
            },
        });
    }
    const handleClearData = async (export_only) => {
        setInitializeClearing(true)
        try {
            let body = {
                export_only,
                clean_tables: cleanTables,
                from_date: deleteFromDate,
                to_date: deleteToDate,
                store_id,
            }
            const response = await axios.post(`${apiUrl}/Data/DeleteData`, body, { headers });
            setInitializeClearing(false);

            const { success, message } = response.data;
            if (success) {

                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            setInitializeClearing(false);
            console.log('error', error);
        }
    }


    const tables = [
        { label: 'Purchase', value: 'inv_purchase' },
        { label: 'Purchase Return', value: 'inv_purchase_return' },
        { label: 'Sale', value: 'inv_sales' },
        { label: 'Sale Return', value: 'inv_sale_return' },
        { label: 'Stock Transfer', value: 'inv_transfers' },
        { label: 'Employee Sale', value: 'inv_employee_sales' },
        { label: 'Orders', value: 'inv_orders' },
        { label: 'Expenses', value: 'expenses' },
        { label: 'Inventory items', value: 'inv_stocks' },
    ];

    const handleCheckBox = (checked, value) => {
        if (checked) {
            setCleanTables((prev) => [...prev, value]);
        } else {
            setCleanTables((prev) => prev.filter((table) => table !== value));
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetExportHistory`, { params: { store_id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    useEffect(() => {
        activeTab === 'BackUpHistory' && GetList();
    }, [activeTab, store_id]);

    const DateBody = (data) => {
        return (
            <div>{formatedDate(data.created_date)}</div>
        );
    };

    const handleDownload = async (data_backupfile_url) => {
        try {
            const response = await fetch(data_backupfile_url);
            const jsonData = await response.json();

            const blob = new Blob(
                [JSON.stringify(jsonData, null, 2)],
                { type: "application/json" }
            );

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `backup_${Date.now()}.json`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const jsonData = JSON.parse(event.target.result);

                // ✅ Extract encrypted_code
                const code = jsonData?.encrypted_code;

                if (!code) {
                    alert("Invalid JSON: encrypted_code not found");
                    return;
                }

                setEncryptedCode(code);
                console.log("Encrypted Code:", code);

            } catch (error) {
                console.error("Invalid JSON file", error);
                alert("Please upload valid JSON file");
            }
        };

        reader.readAsText(file);
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="card mt-3 border-0 overflow-hidden">
                <div className="row g-0">
                    {/* Vertical Tabs Navigation - Left Side */}
                    <div className="col-lg-3 col-md-4">
                        <div className="p-4 h-100" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="mb-4 text-muted fw-semibold">Settings Menu</h5>
                            <div className="d-flex flex-column gap-2">
                                {tabs.map((tab) => (
                                    (!tab.checktab || permissions.includes(tab.auths)) && <motion.button
                                        key={tab.id}
                                        className={`btn btn-link text-start rounded-pill p-3 d-flex align-items-center ${activeTab === tab.id ? `${tab.bgColor} ${tab.color} shadow-sm` : 'text-dark'}`}
                                        style={{ textDecoration: 'none' }}
                                        onClick={() => setActiveTab(tab.id)}
                                        onMouseEnter={() => setIsHovered(tab.id)}
                                        onMouseLeave={() => setIsHovered(null)}
                                        variants={tabVariants}
                                        // initial="hidden"
                                        animate={isHovered === tab.id ? "active" : "visible"}
                                        transition={{ duration: 0.2 }}
                                    >
                                        <i className={`${tab.icon} fs-5 me-3 ${activeTab === tab.id ? tab.color : 'text-muted'}`}></i>
                                        <span className="fw-medium">{tab.title}</span>
                                        {activeTab === tab.id && (
                                            <motion.span
                                                className="ms-auto"
                                                initial={{ scale: 0 }}
                                                animate={{ scale: 1 }}
                                                transition={{ type: 'spring', stiffness: 500 }}
                                            >
                                                <i className="bi bi-chevron-right"></i>
                                            </motion.span>
                                        )}
                                    </motion.button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Tab Content - Right Side */}
                    <div className="col-lg-9 col-md-8">
                        <div className="p-4 h-100">
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={activeTab}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {activeTab === 'Profile' && (
                                        <div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className={`icon-circle bg-blue-100 text-blue-600 me-3`}>
                                                    <i className="pi pi-user fs-4"></i>
                                                </div>
                                                <div>
                                                    <h3 className="mb-0 fw-bold">{userInfo?.user_name ?? "-"}</h3>
                                                    <p className="text-muted">{userInfo?.store_name ?? "-"}</p>
                                                </div>
                                            </div>
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    {/* Advanced content for Today's Sale */}
                                                    <h5 className="fw-semibold mb-0">Sales Analytics</h5>
                                                    <p style={{ fontSize: '12px' }} className='mb-3 mt-0 text-muted font-italic'>Real-time sales monitoring</p>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            {userSales?.total != 0 && <div className="p-3 bg-light rounded d-flex justify-content-center">
                                                                <div style={{ width: "60%" }}>
                                                                    <Chart type="pie" data={salesChart} options={salesChartOptions} />
                                                                </div>
                                                            </div>}
                                                            <p className='text=muted text-center small mt-2'>Total sales ({userSales?.total ?? "0"})</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {/* <div className="p-3 bg-light rounded">
                                                                <p>Real-time sales monitoring</p>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'todaysSale' && (
                                        <div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className={`icon-circle bg-purple-100 text-purple-600 me-3`}>
                                                    <i className="pi pi-chart-bar fs-4"></i>
                                                </div>
                                                <div>
                                                    <h3 className="mb-0 fw-bold">Today's Sale</h3>
                                                    <p className="text-muted">Manage your daily sales configuration</p>
                                                </div>
                                            </div>
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <h5 className="mb-0 fw-semibold">Sales Print</h5>
                                                    </div>

                                                    <div className="row g-3">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="from_date" className="form-label fw-medium">From Date</label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text bg-light">
                                                                        <i className="pi pi-calendar"></i>
                                                                    </span>
                                                                    <input
                                                                        type="date"
                                                                        id="from_date"
                                                                        className="form-control form-control-sm"
                                                                        value={fromDate}
                                                                        onChange={(e) => setFromDate(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="to_date" className="form-label fw-medium">To Date</label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text bg-light">
                                                                        <i className="pi pi-calendar"></i>
                                                                    </span>
                                                                    <input
                                                                        type="date"
                                                                        id="to_date"
                                                                        className="form-control form-control-sm"
                                                                        value={toDate}
                                                                        onChange={(e) => setToDate(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4 d-flex align-items-end">
                                                            <Button
                                                                label="Generate Print"
                                                                icon="pi pi-print"
                                                                className="p-button-success p-button-sm w-100"
                                                                onClick={handlePrint}
                                                                tooltip="Generate sales report for selected dates"
                                                                tooltipOptions={{ position: 'top' }}
                                                            />
                                                        </div>

                                                        {fromDate && toDate && (
                                                            <div className="mt-3 text-muted small">
                                                                <i className="pi pi-info-circle me-1"></i>
                                                                Report will be generated from {formatedDate(fromDate)} to {formatedDate(toDate)}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="row g-3 mt-3">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <div className="input-group">
                                                                    {/* Check Box */}
                                                                    <Checkbox
                                                                        inputId="backup_today_sale"
                                                                        name="backup_today_sale"
                                                                        value="backup_today_sale"
                                                                        checked={isBackUp}
                                                                        onChange={() => setIsBackUp(!isBackUp)}
                                                                    />
                                                                    <label htmlFor="backup_today_sale" className="ml-2 text-capitalize">
                                                                        Backup
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {isBackUp && (
                                                            <div className="col-md-4 d-flex align-items-end">
                                                                <input
                                                                    type="file"
                                                                    accept=".json"
                                                                    className="form-control"
                                                                    onChange={handleFileUpload}
                                                                />
                                                            </div>
                                                        )}
                                                        {isBackUp && encryptedCode && (
                                                            <div className="col-md-12 mt-2">
                                                                <small className="text-success">
                                                                    Encrypted Code Loaded: {encryptedCode}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'clearBackup' && (
                                        <div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className={`icon-circle bg-blue-100 text-blue-600 me-3`}>
                                                    <i className="pi pi-database fs-4"></i>
                                                </div>
                                                <div>
                                                    <h3 className="mb-0 fw-bold">Clear & Backup</h3>
                                                    <p className="text-muted">Data management and security</p>
                                                </div>
                                            </div>
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-body">

                                                    <h5 className="mb-3 fw-semibold">Database Operations</h5>
                                                    <div className="alert alert-warning">
                                                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                        These operations are irreversible. Proceed with caution.
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <div className="input-group">
                                                                    <span className="input-group-text bg-light">
                                                                        <i className="pi pi-calendar"></i>
                                                                    </span>
                                                                    <input
                                                                        type="date"
                                                                        id="from_date"
                                                                        className="form-control form-control-sm"
                                                                        value={deleteFromDate}
                                                                        onChange={(e) => setDeleteFromDate(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <div className="input-group">
                                                                    <span className="input-group-text bg-light">
                                                                        <i className="pi pi-calendar"></i>
                                                                    </span>
                                                                    <input
                                                                        type="date"
                                                                        id="to_date"
                                                                        className="form-control form-control-sm"
                                                                        value={deleteToDate}
                                                                        onChange={(e) => setDeleteToDate(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <div className="card h-100 border-danger">
                                                                <div className="card-body">
                                                                    <h6 className="text-danger">Clear Data</h6>
                                                                    <p className='my-2'>Permanently delete selected data</p>

                                                                    <div className="row mt-0">
                                                                        {tables.map((table, i) => {
                                                                            return (
                                                                                <div key={i} className="col-md-6 mt-2">
                                                                                    <Checkbox
                                                                                        inputId={i}
                                                                                        name="table"
                                                                                        value={table.value}
                                                                                        checked={cleanTables.includes(table.value)}
                                                                                        onChange={(e) => handleCheckBox(e.checked, e.target.value)}
                                                                                    />
                                                                                    <label htmlFor={i} className="ml-2 text-capitalize">
                                                                                        {table.label}
                                                                                    </label>
                                                                                    <br />
                                                                                    {table.value === 'inv_stocks' && <span className='text-muted text-capitalize' style={{ fontSize: '12px' }}>(recommended) But Take time</span>}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    <button className="btn btn-outline-danger btn-sm mt-3 float-end" disabled={initializeClearing || cleanTables.length === 0 || !deleteFromDate || !deleteToDate} onClick={() => handleClearDataConformation("1")}>
                                                                        {initializeClearing ? "Please Wait ...!" : "Initialize Clear"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-6 mb-3">
                                                            <div className="card border-success">
                                                                <div className="card-body">
                                                                    <h6 className="text-success">Backup Data</h6>
                                                                    <p>Create a secure backup</p>
                                                                    <button className="btn btn-outline-success btn-sm" disabled={initializeClearing} onClick={() => handleClearDataConformation("2")}>
                                                                        {initializeClearing ? "Please Wait ...!" : "Create Backup"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    {activeTab === 'BackUpHistory' && (
                                        <div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className={`icon-circle bg-purple-100 text-purple-600 me-3`}>
                                                    <i className="pi pi-history fs-4"></i>
                                                </div>
                                                <div>
                                                    <h3 className="mb-0 fw-bold">History</h3>
                                                    <p className="text-muted">Clear & Backup</p>
                                                </div>
                                            </div>
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    {/* Advanced content for Today's Sale */}
                                                    <h5 className="fw-semibold mb-3">History Report</h5>
                                                    <div className="row bg-light">
                                                        {dataTableLoading ? (
                                                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                                                <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                                                            ))
                                                        ) : (
                                                            <DataTable
                                                                value={rows}
                                                                rows={10}
                                                                size='small'
                                                            >
                                                                <Column field={DateBody} header="Date" />
                                                                <Column field="file_size" header="Size" />
                                                                <Column
                                                                    field="tables_affected"
                                                                    header="Selected Options"
                                                                    body={(rowData) => {
                                                                        return (
                                                                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={rowData.tables_affected}>
                                                                                {rowData.tables_affected && rowData.tables_affected.length > 20 ? rowData.tables_affected.slice(0, 20) + '...' : rowData.tables_affected}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />

                                                                <Column field="export_type" header="Export" />
                                                                <Column field="user_name" header="Export By" />
                                                                <Column
                                                                    field={(data) => (
                                                                        <i
                                                                            className="pi pi-download"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => handleDownload(data.data_backupfile_url)}
                                                                        />
                                                                    )}
                                                                    header="Download"
                                                                />
                                                            </DataTable>

                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;